import z from 'zod';

export interface PhoneNumberTwilioDetailsDto {
  carrier: string;
  type: string;
}

export const phoneNumberSchema = z.object({
  userId: z.string(),
  phoneId: z.number().optional().nullable(),
  phoneType: z.string().optional(),
  number: z
    .string()
    .regex(/^\+1\d{10}$/, 'Phone number must be in format +1 followed by 10 digits'),
  description: z.string().min(1, 'Description is required'),
  primary: z.boolean(),
});

export const phoneNumberEditSchema = z.object({
  userId: z.string().optional(),
  description: z.string().optional(),
  primary: z.boolean().optional(),
  phoneId: z.number().optional().nullable(),
  number: z.string().optional(),
});
export type CreatePhoneNumberRequest = z.infer<typeof phoneNumberSchema>;
export type UpdatePhoneNumberRequest = z.infer<typeof phoneNumberEditSchema>;
